import { useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';

export const useApi = (path, params = null, { enabled = true } = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);
  const key = JSON.stringify(params);

  const load = useCallback(async () => {
    if (!enabled) { setLoading(false); return; }
    setLoading(true);
    setError(null);
    try {
      const res = await api.get(path, { params: JSON.parse(key) || undefined });
      setData(res.data);
    } catch (e) {
      console.error(`GET ${path} failed`, e);
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [path, key, enabled]);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, reload: load };
};
